import React from 'react';
import Offline from '../components/Offline';
import NavBar from '../components/NavBar';
import NavBarConfig from '../components/NavBarConfig';
import Sidebar from '../components/Sidebar';

export default function Navigation({ children, user }) {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: 'transparent', overflow: 'hidden', position: 'relative' }}>
      <Offline />
      
      {/* Left Sidebar */}
      <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
      
      {/* Configuration component for Redux */}
      <NavBarConfig user={user} />
      
      {/* Main Content Area (Right Side) */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
        
        {/* Top Bar (formerly NavBar) */}
        <NavBar toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
        
        {/* Page Content */}
        <div style={{ flex: 1, overflowY: 'auto' }}>
          {React.cloneElement(children, { user })}
        </div>
      </div>
      
    </div>
  );
}
